import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class RedirectProps {
  @Inlet(Accepts.RedirectBehaviour)
  public behaviour?: Types["RedirectBehaviour"];

  @Inlet(Accepts.Url) public url?: Types["Url"];

  @Inlet(Accepts.RelatedStoryList) public stories?: Types["RelatedStoryList"];

  @Inlet(Accepts.String) public preTitle?: Types["String"];
  @Inlet(Accepts.String) public title?: Types["String"];
}

export const RedirectDefinition = defineElement("redirect", RedirectProps, {
  versionRequired: "0.37.0",
});
